import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '../../../../Apollo/Mutation';
import ActivateAccountMutation from './ActivateAccountMutation';

class ActivateAccountConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    createActivateAccount = mutate => async request => {
        const variables = request;

        const response = await mutate({
            variables,
        });

        return response;
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={ActivateAccountMutation}>
                {mutate =>
                    children({
                        activateAccount: this.createActivateAccount(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default ActivateAccountConnectorApollo;
